export const getRandomIntBetween = (min, max) => {
  const parsedMin = Math.ceil(min);
  const parsedMax = Math.floor(max);
  return Math.floor(Math.random() * (parsedMax - parsedMin) + parsedMin); // The maximum is exclusive and the minimum is inclusive
};
